import { useEffect, useState } from "react";
import { Box, Container } from "@mui/material";
import Header from "./Header";
import Footer from "./Footer";
import './index.css'
import axios from "axios";

const API_URL = process.env.REACT_APP_APPLICATION_ENDPOINT + "/public/consulta/links";
const CACHE_KEY = "public_links";
const CACHE_TIME_KEY = "public_links_time";
const EXPIRATION_HOURS = 8;

export const PublicRoute = ({ children }: { children: any }) => {
  const [links, setLinks] = useState<any[]>([]);

  useEffect(() => {
    const loadLinks = async () => {
      const cachedLinks = localStorage.getItem(CACHE_KEY);
      const cachedTime = localStorage.getItem(CACHE_TIME_KEY);

      const now = new Date();
      const lastFetch = cachedTime ? new Date(cachedTime) : null;
      const timePassed = lastFetch
        ? (now.getTime() - lastFetch.getTime()) / (1000 * 60 * 60)
        : Infinity;

      if (!cachedLinks || timePassed > EXPIRATION_HOURS) {
        try {
          const response = await axios.get(API_URL);
          const rawData = response.data;

          const filteredData = rawData.map((item: any) => ({
            link: item.link,
            texto: item.texto,
            zona: item.zona,
            es_icono: item.es_icono,
          }));

          localStorage.setItem(CACHE_KEY, JSON.stringify(filteredData));
          localStorage.setItem(CACHE_TIME_KEY, now.toISOString());
          setLinks(filteredData);
        } catch (error) {
          console.error("Error al cargar los links públicos:", error);
        }
      } else {
        setLinks(JSON.parse(cachedLinks));
      }
    };

    loadLinks();
  }, []);

  if (process.env.REACT_APP_HAS_FRONT !== "SI") {
    return <p>404 - No encontrado</p>
  }

  return (

    <Box sx={{ width: "100%" }}>
      <Header links={links} />

      <Container maxWidth="lg" sx={{ width: "100%", fontFamily: "'Maven Pro', sans-serif" }}>
        {children}
      </Container>

      <Footer links={links} />
    </Box>

  );
};
